import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialOperationFoldersPageState,
  OperationFoldersItemData,
  OperationFoldersListResponse,
  OperationFoldersListStateType,
} from "../core/_model.operation-folders";

export const defaultPageState = {
  page: 1,
  itemsPerPage: 10,
};

export type ActionedTeam = {
  data: OperationFoldersItemData | null;
  action: ActionsKey;
};

export type ActionedOperationFolders = {
  data: OperationFoldersItemData;
  action: ActionsKey;
};

type OperationFoldersDataType = {
  operationFoldersList: any;
  detail: OperationFoldersItemData | null;
  actioned: ActionedOperationFolders | null;
  totalItems?: number;
  setDetail: (detail: OperationFoldersItemData | null) => void;
  setOperationFoldersList: (roles: OperationFoldersListResponse | null) => void;
  setActioned: (act: ActionedTeam | null) => void;
  pageState: any;
  setPageState: (state: any) => void;
  resetPageState: () => void;
};

export const useOperationFoldersStore = create<OperationFoldersDataType>(
  (set) => ({
    operationFoldersList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    pageState: defaultPageState,
    setDetail: (detail) => set((state) => ({ detail })),
    setOperationFoldersList: (operationFoldersData) =>
      set(() => ({
        operationFoldersList: operationFoldersData?.member,
        totalItems: operationFoldersData?.totalItems ?? 0,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);

export const useOperationFoldersListState = create<OperationFoldersListStateType>(
  (set) => ({
    pageState: initialOperationFoldersPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);